module.exports = __webpack_public_path__ + "static/media/Diploma mat Single.4ced7916.jpg";